<template>
    <div>
        <v-btn class="hide" color="primary" large @click="$router.back()"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <v-btn color="primary" class="ml-2 hide" large :loading="isLoading" :disabled="isLoading" id="printDay" @click="printDailyView"><v-icon>mdi-printer</v-icon></v-btn>
        <div v-for="(booking, index) in bookings" :key="index" >
            <daily-booking :booking="booking" />
            <div class="break"></div>
        </div>

    </div>
</template>

<script>
    import {BookingsHttp} from "../http/bookings";
    import DailyBooking from "./DailyBooking";

    export default {
        name: "DailyPrintView",
        components: {DailyBooking},
        async mounted() {
            this.bookings = await BookingsHttp.fetchPublicBookings(this.$moment().toDate().toISOString().substr(0, 10), false).then(result => result.data.bookings);
        },
        data() {
            return {
                bookings: [],
                isLoading: false
            }
        },
        methods: {
            async printDailyView() {
                this.isLoading = true;
                const blob = await BookingsHttp.printDailyBookings();
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                window.open(link.href, '_blank');
                this.isLoading = false;
            }
        }
    }
</script>

<style scoped>
    @media print {
        .hide {
            display: none;
        }
        .break {
            page-break-after: always;
        }
    }
</style>
